import { createFileRoute, redirect } from '@tanstack/react-router'

// This page was merged into /admin/request-tracking, which now switches
// between the proxy-api and base-llm-proxy-api datasets via `?dataset=`.
// Kept only so existing bookmarks land on the right dataset instead of 404ing.
export const Route = createFileRoute('/admin/base-request-tracking')({
  beforeLoad: () => {
    throw redirect({
      href: '/admin/request-tracking?dataset=base_llm_proxy_api_requests',
    })
  },
})
